module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightbulb-c0fce49a.svg";